<template>
    <div>
      <h2>Hilfe</h2>
      <div>
          Sollte etwas nicht funktionieren, gib uns bitte kurz Bescheid.
          <br />
          Alle Bilder wurden für die Online-Galerie ein wenig verkleinert. Wenn du ein Bild in Originalgröße haben möchtest, schicken wir es dir gerne zu.
          <br />
          <br />
          <div>
              mail@tjones.de <br />
              anikajonas1210@gmail.com
          </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Impressum',
  created: function () {
  },
  data: function () {
    return {
    }
  }
}
</script>

<style>
div{
  margin-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/Help.vue